<ng-container *ngIf="isImageBanner; else normalBanner">
  <div class="w-100 bg-primary">
    <div class="container">
      <img class="my-4 image-banner w-100" [src]="imageBannerUrl | contentAssetImage" alt="" />
    </div>
  </div>
</ng-container>
<ng-template #normalBanner>
  <div
    class="banner"
    [ngClass]="{ 'banner-corporate': isCorporate }"
    [style.background-image]="!isCorporate ? 'url(' + ('banners/banner-bg.jpg' | contentAssetImage) + ')' : null"
  >
    <div class="container d-flex align-items-center justify-content-between w-100">
      <div *ngIf="isHomePage">
        <a class="d-flex align-items-center" [routerLink]="['/account']" [routerLinkActive]="'active'">
          <h1 class="font-size-18" [ngClass]="{ 'font-corporate': isCorporate, 'font-default': !isCorporate }">
            {{ title }}
          </h1>
          <span class="material-symbols-outlined text-white mb-1">chevron_right</span>
        </a>
        <div class="d-flex font-size-14 text-white align-items-center">
          <div *notInPopulation="[populations.JuniorBluebirds]">{{ 'member.card.product.code' | translate }}</div>
          <div *inPopulation="[populations.JuniorBluebirds]">{{ 'member.card.product.code.kid' | translate }}</div>
          <div class="vertical-line-div mx-2"></div>
          <div>ID: {{ memberId }}</div>
        </div>
      </div>
      <ng-container *ngIf="!isHomePage">
        <h1 [ngClass]="{ 'font-corporate': isCorporate, 'font-default': !isCorporate }">
          {{ title }}
        </h1>
      </ng-container>
      <img *ngIf="!isCorporate && !isKid" class="banner-logo" [src]="'logos/logo.svg' | contentAssetImage" draggable="false" />
      <img *ngIf="isCorporate" class="banner-logo" [src]="'logos/corporate-logo.png' | contentAssetImage" draggable="false" />
      <img *ngIf="isKid" class="banner-logo" [src]="'logos/kid-logo.png' | contentAssetImage" draggable="false" />
    </div>
  </div>
</ng-template>
